import React, {PureComponent} from 'react';
import {FastField, FieldArray, ErrorMessage} from 'formik';
import {FormattedMessage} from 'react-intl';
import get from 'lodash/get';
import classNames from 'classnames';
import messages from '../../../../../res/translations/messages';
import FormGroup from '../FormGroup';
import CommonFields from './CommonFields';
import Rank1RowType from './Rank1RowType';
import Error from '../../../Error';

class Rank1Type extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const {name, form, previousPages} = this.props;

        return (
            <>
                <CommonFields name={name} form={form} required={true} previousPages={previousPages} />
                <div className="row">
                    <FormGroup name={`${name}.max`} label={messages.surveys.form.label.minRanking} size={4}
                        tooltip={messages.surveys.form.label.minRankingLabel}>
                        <FastField id={`${name}.max`} name={`${name}.max`} type="number" step="any"
                            className={classNames('form-control',
                                {error: get(form.errors, `${name}.max`) && get(form.touched, `${name}.max`)})} />
                        <ErrorMessage name={`${name}.max`}>{(message) => <Error reason={message.key} reasonParams={message.params} />}</ErrorMessage>
                    </FormGroup>
                </div>
                <div className="form-group">
                    <h4>
                        &gt; <FormattedMessage {...messages.surveys.form.label.rows} />
                    </h4>
                    <FieldArray name={`${name}.rows`} component={Rank1RowType} previousPages={previousPages} />
                    <ErrorMessage name={`${name}.rows`}>{(message) => <Error reason={message.key} reasonParams={message.params} />}</ErrorMessage>
                </div>

            </>
        );
    }
}

export default Rank1Type;
